import { Serializable } from '@/models/core/serializable';
import { JgrowEventLikertScaleItem } from '@/models/jgrow/jgrow-event-likert-scale-item';
import { JgrowEventLikertScaleAnswer } from '@/models/jgrow/jgrow-event-likert-scale-answer';


export class JgrowEventLikertScale implements Serializable<JgrowEventLikertScale> {
  ID: number; // 設問ID
  title: string;
  items: JgrowEventLikertScaleItem[] = [new JgrowEventLikertScaleItem()];
  answers: JgrowEventLikertScaleAnswer[] = [];
  validation: boolean = true; // 初期表示や編集時にはバリデーションエラーを表示しないため 初期値は true

  deserialize(input: any): JgrowEventLikertScale {
    this.ID = input.ID;
    this.title = input.title;
    this.items = input.items
    .sort((a: JgrowEventLikertScaleItem, b: JgrowEventLikertScaleItem) => a.value - b.value)
    .map((item: JgrowEventLikertScaleItem) => new JgrowEventLikertScaleItem().deserialize(item));
    // 回答が存在する場合は保持する
    if (input.hasOwnProperty("answer") && input.answer != null && input.answer != undefined) {
      this.answers = input.answer.map((lsa: JgrowEventLikertScaleAnswer) => new JgrowEventLikertScaleAnswer().deserialize(lsa));
    }

    return this;
  }

  get isValid(): boolean {
    return this.validation;
  }

  get isValidError(): boolean {
    return !this.validation;
  }

  get generateKey(): string {
    return 'ilkert_' + this.ID;
  }

  deleteItems(i: number) {
    this.items.splice(i, 1);
    let order = 0;
    this.items.forEach((lsi: JgrowEventLikertScaleItem) => {
      order++;
      lsi.value = order;
    });
  }

  doValidation(): boolean {
    if (this.title == "" || this.title == null || this.title == undefined) {
      this.validation = false;
    } else {
      this.validation = true;
    }
    const falseResult = this.items.filter((lsi: JgrowEventLikertScaleItem) => lsi.doValidation() === false);

    return this.validation && falseResult.length < 1;
  }
}
